<script>
    export let title = "";
    export let subtitle = "";
    export let hasContent = true;
  </script>
  
  <section class="max-w-3xl space-y-4">
    <div>
      <h2 class="text-lg font-bold text-[var(--app-title-color)]">{title}</h2>
      <p class="text-sm text-[var(--app-text-color-darker)]">{subtitle}</p>
    </div>
    {#if hasContent}
      <div class="border rounded p-6" style="background-color: var(--app-background-level-1); border-color: var(--app-background-level-3);">
        <slot></slot>
      </div>
    {/if}
  </section>